import Phaser from 'phaser';

const GAME_WIDTH = 800;
const GAME_HEIGHT = 600;
const PLAYER_SPEED = 300;
const PLAYER_Y_POSITION = GAME_HEIGHT - 50;

class MainScene extends Phaser.Scene {
  private isPlaying = false;
  private titleText!: Phaser.GameObjects.Text;
  private subtitleText!: Phaser.GameObjects.Text;
  private promptText!: Phaser.GameObjects.Text;
  private spaceKey!: Phaser.Input.Keyboard.Key;
  private player!: Phaser.Physics.Arcade.Sprite;
  private cursors!: Phaser.Types.Input.Keyboard.CursorKeys;

  constructor() {
    super({ key: 'MainScene' });
  }

  preload(): void {
    // Create player ship sprite texture programmatically
    this.createPlayerTexture();
  }

  private createPlayerTexture(): void {
    const graphics = this.make.graphics({ x: 0, y: 0 });

    // Draw a classic space invaders style ship
    // Ship body (main hull)
    graphics.fillStyle(0x00ff00);
    graphics.fillRect(16, 8, 16, 16);  // Center body
    graphics.fillRect(8, 16, 32, 8);   // Wide base
    graphics.fillRect(4, 20, 40, 4);   // Bottom bar

    // Cannon
    graphics.fillRect(22, 0, 4, 8);    // Top cannon

    // Wing accents
    graphics.fillStyle(0x00cc00);
    graphics.fillRect(0, 20, 4, 4);    // Left wing tip
    graphics.fillRect(44, 20, 4, 4);   // Right wing tip

    // Generate texture from graphics
    graphics.generateTexture('player-ship', 48, 24);
    graphics.destroy();
  }

  create(): void {
    // Display a placeholder message
    this.titleText = this.add.text(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 50, 'SPACE INVADERS 2030', {
      fontSize: '48px',
      color: '#00ff00',
      fontFamily: 'monospace',
    }).setOrigin(0.5);

    this.subtitleText = this.add.text(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 20, 'Game scaffold initialized', {
      fontSize: '24px',
      color: '#ffffff',
      fontFamily: 'monospace',
    }).setOrigin(0.5);

    this.promptText = this.add.text(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 60, 'Press SPACE to start', {
      fontSize: '18px',
      color: '#888888',
      fontFamily: 'monospace',
    }).setOrigin(0.5);

    // Set up keyboard input
    this.spaceKey = this.input.keyboard!.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
    this.cursors = this.input.keyboard!.createCursorKeys();
  }

  private startGame(): void {
    this.isPlaying = true;

    // Hide title screen elements
    this.titleText.setVisible(false);
    this.subtitleText.setVisible(false);
    this.promptText.setVisible(false);

    // Show game title at top
    this.add.text(GAME_WIDTH / 2, 30, 'SPACE INVADERS 2030', {
      fontSize: '24px',
      color: '#00ff00',
      fontFamily: 'monospace',
    }).setOrigin(0.5);

    // Create the player ship
    this.player = this.physics.add.sprite(GAME_WIDTH / 2, PLAYER_Y_POSITION, 'player-ship');
    this.player.setCollideWorldBounds(true);
  }

  update(_time: number, _delta: number): void {
    // Check for space key press to start the game
    if (!this.isPlaying && Phaser.Input.Keyboard.JustDown(this.spaceKey)) {
      this.startGame();
      return;
    }

    // Handle player movement when playing
    if (this.isPlaying && this.player) {
      if (this.cursors.left.isDown) {
        this.player.setVelocityX(-PLAYER_SPEED);
      } else if (this.cursors.right.isDown) {
        this.player.setVelocityX(PLAYER_SPEED);
      } else {
        this.player.setVelocityX(0);
      }
    }
  }
}

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  parent: 'game-container',
  backgroundColor: '#000000',
  scene: [MainScene],
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
};

export const game = new Phaser.Game(config);
